// extracted by mini-css-extract-plugin
export default {"customer-image":"CustomerList_customer-image__jgw3t"};